import React, { useState } from 'react';
import { BookOpen, ChevronDown, ChevronUp, Download } from 'lucide-react';
import generateDebriefPDF from '../../utils/generateDebriefPDF';
import { bilanMecaniques } from '../../utils/mecaniques';

/**
 * SCD — Débrief pédagogique d'une équipe (vue Supervision, dépliable).
 * Alimenté par le champ télémétrie `dgs_debrief` (généré en fin de scénario).
 */
export default function DebriefBlock({ debrief, licenseKey, snapshot = {}, holderName }) {
  const [open, setOpen] = useState(false);
  if (!debrief) return null;
  const { pointsForts = [], aTravailler = [], conseils = [] } = debrief;
  if (!pointsForts.length && !aTravailler.length && !conseils.length) return null;

  return (
    <div className="col-span-2 lg:col-span-4 border border-purple-500/30 rounded-lg bg-purple-500/5" data-testid={`debrief-block-${licenseKey}`}>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        className="w-full flex items-center justify-between px-3 py-2 text-xs font-bold text-purple-200"
        data-testid={`debrief-toggle-${licenseKey}`}
      >
        <span className="flex items-center gap-1.5"><BookOpen className="w-3.5 h-3.5" /> Débrief pédagogique (fin de scénario)</span>
        {open ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-3">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-[11px]">
          <div>
            <p className="uppercase text-[9px] tracking-wider text-emerald-300 font-bold mb-1">Points forts</p>
            {pointsForts.length === 0 && <p className="text-slate-500 italic">—</p>}
            <ul className="space-y-1">{pointsForts.map((p, i) => <li key={i} className="text-slate-300">• {p}</li>)}</ul>
          </div>
          <div>
            <p className="uppercase text-[9px] tracking-wider text-amber-300 font-bold mb-1">Points à travailler</p>
            {aTravailler.length === 0 && <p className="text-slate-500 italic">—</p>}
            <ul className="space-y-1">{aTravailler.map((p, i) => <li key={i} className="text-slate-300">• {p}</li>)}</ul>
          </div>
          <div>
            <p className="uppercase text-[9px] tracking-wider text-sky-300 font-bold mb-1">Conseils</p>
            {conseils.length === 0 && <p className="text-slate-500 italic">—</p>}
            <ul className="space-y-1">{conseils.map((p, i) => <li key={i} className="text-slate-300">• {p}</li>)}</ul>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            generateDebriefPDF({
              companyName: snapshot.company_name,
              scenarioNom: snapshot.scenario_id || 'Scénario de session',
              holderName,
              resultat: {
                treasury: snapshot.treasury || 0,
                caCumul: snapshot.retail_ca_cumul || 0,
                satisfaction: snapshot.retail_satisfaction || 0,
                nbMagasins: snapshot.retail_nb_magasins || 1,
                caWebCumul: snapshot.retail_ca_web_cumul || 0,
                equipements: snapshot.retail_equipements || null,
                mecaniques: bilanMecaniques(snapshot.retail_mecaniques || []),
                franchise: snapshot.retail_franchise || null,
                groupe: snapshot.retail_groupe || null,
                merchandising: snapshot.retail_merch || null,
                score: snapshot.dgs_score,
                debrief,
              },
            });
          }}
          className="flex items-center gap-1.5 text-[11px] font-bold text-purple-300 hover:text-purple-100 transition-colors"
          data-testid={`debrief-pdf-${licenseKey}`}
        >
          <Download className="w-3.5 h-3.5" /> Fiche PDF de l'équipe
        </button>
        </div>
      )}
    </div>
  );
}
